import React from "react";

const getViewBox = name => {
  switch (name) {
    case "world":
      return "0 0 36 36";
    case "suitcase":
      return "0 0 28 26";
    case "filter":
      return "0 0 25 25";
    case "stars":
      return "0 0 30 30";
    case "home":
      return "0 0 24 24";
    case "network":
      return "0 0 28 28";
    case "reference":
      return "0 0 78 78";
    case "collapse":
      return "0 0 70 65";
    case "close":
      return "0 0 15 15";
    case "eye":
      return "0 0 32 20";
    case "zoom-out":
    case "zoom-in":
    case "startover":
    case "settings":
      return "0 0 32 32";
    case "arrow-down":
      return "0 0 38 24";
    case "growth":
    case "portfolio":
    case "chart":
    case "lady":
    case "people":
      return "0 0 50 50";
    case "binoculars":
      return "0 10 50 30";
    case "marker":
      return "0 0 41 39";
    case "prev":
    case "next":
      return "0 0 12 20";
    case "up":
    case "down":
      return "0 0 20 12";
    default:
      return "0 0 36 36";
  }
};

const getPath = (name, props) => {
  switch (name) {
    case "world":
      return (
        <g {...props} ><path fill={props.fill} d="M7.3359 32.0439c.903-.672 1.637-2.408 1.637-2.408s.79-.56 1.072-1.232c.283-.672 0-1.68 0-1.68s.734-2.072.395-2.632c-.338-.56-1.75-.952-1.75-.952s-.564-1.064-1.806-1.288c-.79-.056-1.58-.616-1.58-1.736s1.129-2.912 1.129-2.912 1.185-.56 1.355-1.008c.169-.448.225-1.4.225-1.4s1.129-1.96.509-3.08c-.227-.336-1.13-.616-1.13-.616l-1.298-1.96M27.3188 29.0762c-1.411-.672-3.895-1.232-3.895-1.232s-1.806-2.016-2.992-1.848c-1.185.168-2.371 1.512-2.371 1.512s.057 2.464-.282 2.576c-.395.112-1.355-.56-1.976-.056s-.282 1.904-.282 1.904-1.355.448-1.524.896c-.169.448.508 1.456.621 1.848" /><path d="M16 5.5h-.253C7.618 5.5 1.07 11.996 1.07 20.06s6.548 14.56 14.677 14.56c8.128 0 14.677-6.496 14.677-14.56 0-1.568-.226-3.08-.734-4.48" /><path d="M29.2949 7.6279c0 4.032-6.774 10.248-6.774 10.248s-6.774-6.216-6.774-10.248c0-4.144 3.5-6.552 6.774-6.552s6.774 2.408 6.774 6.552z" /><path d="M22.521 5.5562c1.247 0 2.258 1.003 2.258 2.24 0 1.237-1.011 2.24-2.258 2.24s-2.258-1.003-2.258-2.24c0-1.237 1.011-2.24 2.258-2.24z" /></g>
      );
    case "suitcase":
      return (
        <g {...props}><path d="M10.1343 4.1079c0-.992.787-1.778 1.778-1.778h4.241c.992 0 1.778.786 1.778 1.778v1.984h1.881v-1.984c0-2.018-1.641-3.659-3.659-3.659h-4.241c-2.018 0-3.659 1.641-3.659 3.659v1.984h1.881v-1.984zM27.1313 12.7607l-10.123 3.42v1.642c0 .718-.582 1.299-1.3 1.299h-3.351c-.719 0-1.3-.581-1.3-1.299v-1.642l-10.123-3.42v12.791h26.231v-12.791h-.034z" /><path d="M11.0576 14.4365c0-.718.581-1.3 1.299-1.3h3.352c.718 0 1.3.582 1.3 1.3v.376l10.123-3.42v-3.933H.9336v3.967l10.124 3.42v-.41z" /><path d="M12.3569 14.4023c-.034 0-.034.034-.034.034v3.352c0 .034.034.034.034.034h3.352c.034 0 .034-.034.034-.034v-3.352c0-.034-.034-.034-.034-.034h-3.352z" /></g>
      );
    case "stars":
      return (
        <g {...props}><path d="M15 .4595l.773 2.38h2.503l-2.025 1.472.774 2.38L15 5.2205l-2.025 1.471.774-2.38-2.025-1.472h2.503zM4.7183 4.7183l2.23 1.136 1.77-1.769-.392 2.471 2.23 1.137-2.472.391-.391 2.472-1.137-2.23-2.471.392 1.769-1.77zM.4595 15l2.38-.773v-2.503l1.472 2.025 2.38-.774L5.2205 15l1.471 2.025-2.38-.774-1.472 2.025v-2.503zM4.7183 25.2817l1.136-2.23-1.769-1.77 2.472.392 1.136-2.23.391 2.472 2.472.391-2.23 1.137.392 2.471-1.77-1.769zM15 29.5405l-.773-2.38h-2.503l2.025-1.472-.774-2.379 2.025 1.47 2.025-1.47-.774 2.379 2.025 1.472h-2.503zM25.2817 25.2817l-2.23-1.136-1.77 1.769.392-2.471-2.23-1.137 2.472-.391.391-2.472 1.137 2.23 2.471-.392-1.769 1.77zM29.5405 15l-2.38.773v2.503l-1.472-2.025-2.379.774L24.7805 15l-1.471-2.025 2.379.774 1.472-2.025v2.503zM25.2817 4.7183l-1.136 2.23 1.769 1.77-2.471-.392-1.137 2.23-.391-2.472-2.472-.391 2.23-1.137-.392-2.471 1.77 1.769z" /></g>
      );
    case "network":
      return (
        <g fill="none" fillRule="evenodd"><path fill={props.fill} d="M5.4502.79c2.621 0 4.745 2.125 4.745 4.746 0 2.62-2.124 4.745-4.745 4.745S.7042 8.156.7042 5.536c0-2.621 2.125-4.746 4.746-4.746M21.4814 8.4424c3.211 0 5.814 2.603 5.814 5.814s-2.603 5.814-5.814 5.814-5.814-2.603-5.814-5.814 2.603-5.814 5.814-5.814M4.2959 20.0278c1.983 0 3.591 1.607 3.591 3.591 0 1.983-1.608 3.591-3.591 3.591s-3.591-1.608-3.591-3.591c0-1.984 1.608-3.591 3.591-3.591" /><path stroke={props.stroke} strokeWidth={props.strokeWidth} d="M7.6304 22.165l9.063-4.574M16.1802 11.8623l-6.541-4.061M5.2788 10.2378l-1.368 9.79" /></g>
      );
    case "filter":
      return (
        <g {...props} ><path d="M1.2998 1.2998h22.4l-8.8 12v10.4h-4.8v-10.4z" /></g>
      );
    case "home":
      return (
        <g fill="none" fillRule="evenodd"><path fill={props.fill} d="M12 .2402l-11 11h2.64v12.52h5.72v-9.12H14.64v9.12h5.72v-12.52H23z" /><path stroke={props.stroke} strokeWidth={props.strokeWidth} d="M12 .2402l-11 11h2.64v12.52h5.72v-9.12H14.64v9.12h5.72v-12.52H23z" /></g>
      );
    case "reference":
      return (
        <g {...props}><path d="M13.6 22.6c6 0 10.9-5 10.7-11.1C24 6 19.5 1.5 14 1.3 7.9 1.1 2.9 5.9 2.9 11.9c0 0 0 0 0 0 0 5.9 4.8 10.7 10.7 10.7zm0-19.6c5.2 0 9.4 4.5 8.8 9.9-.4 4.1-3.8 7.4-7.8 7.8-5.4.6-9.9-3.6-9.9-8.8 0 0 0 0 0 0C4.7 7 8.7 3 13.6 3zM2.9 50.5H24v-21H2.9v21zm1.8-19.3h17.6v17.6H4.7V31.2zM2.1 76.9h22.6L13.4 57.3 2.1 76.9zm3-1.8l8.2-14.3 8.2 14.3H5.1zM70.4 11H32c-.5 0-.9.4-.9.9s.4.9.9.9h38.4c.5 0 .9-.4.9-.9s-.5-.9-.9-.9zM69.5 39.1H31.1c-.5 0-.9.4-.9.9s.4.9.9.9h38.4c.5 0 .9-.4.9-.9s-.4-.9-.9-.9zM69.5 66.3H31.1c-.5 0-.9.4-.9.9s.4.9.9.9h38.4c.5 0 .9-.4.9-.9s-.4-.9-.9-.9z" /></g>
      );
    case "collapse":
      return (
        <g {...props}><path stroke={props.stroke} strokeWidth={props.strokeWidth} d="M29.9 61.6l1-25.8L6 35.2 5.6 44l9.5.2L.2 57.9l6.1 6.3 14.9-13.6-.3 9.6 8.9 1.4zM39.6 4.5l-1 24.8 24.9.6.4-8.8-9.5-.3 15-13.6L63.2.8 48.3 14.5l.3-10.8-9.6.8z" /></g>
      );
    case "close":
      return (
        <g {...props}><path d="M7.5.9766c3.603 0 6.523 2.921 6.523 6.523 0 3.603-2.92 6.524-6.523 6.524-3.603 0-6.523-2.921-6.523-6.524 0-3.602 2.92-6.523 6.523-6.523zM4.2812 4.2812l6.437 6.437M10.7187 4.2812l-6.437 6.437" /></g>
      );
    case "eye":
      return (
        <g {...props}><path d="M16 1.25C7.4 1.25 1.25 10 1.25 10S7.4 18.75 16 18.75 30.75 10 30.75 10 24.6 1.25 16 1.25z" /><path d="M16 3.75c3.313 0 6 2.687 6 6s-2.687 6-6 6-6-2.687-6-6 2.687-6 6-6z" /></g>
      )
    case "zoom-out":
      return (
        <g {...props}><circle fill="transparent" cx="15.7" cy="15.4" r="11.2" /><path d="M8.1 15.4h15.3" /></g>
      )
    case "zoom-in":
      return (
        <g {...props}><circle fill="transparent" cx="16.1" cy="15.6" r="10.7" /><path d="M16.2 8.2v14.9M23.5 15.5H8.6" /></g>
      )
    case "startover":
      return (
        <g {...props}><path d="M19.3 25.2l-3.1 3.1-3.1-3.2M24.9 13.3l3.2 3.2-3.1 3.2M13.1 7.7l3.1-3.1 3.1 3.2M7.5 19.6l-3.2-3.2 3.1-3.2m-3.1 3.3H28M16.2 4.5v23.8" /></g>
      )
    case "settings":
      return (
        <g {...props}><path d="M12.7 10.2h-7M25.3 10.2h-3.5M16.9 6h4.9v8.4h-4.9zM18.3 22.8h7M5.7 22.8h3.5M9.2 18.6h4.9V27H9.2z" /></g>
      )
    case "arrow-down":
      return (
        <g {...props}><path strokeWidth="1" fill="none" d="M9.4 7.2l9.6 9.6 9.6-9.6" /></g>
      )
    case "growth":
      return (
        <g {...props}><path d="M6.7 6.5v36.7H44M28 17.4l9.9 5-.5-10.9z" /><path d="M11.8 37.2l4.8-8.6H28l4.9-8.5" /></g>
      )
    case "portfolio":
      return (
        <g {...props}><path d="M7 13.1h36.8v27.6H7zM18 13.1v-4h14.6v4" /><path d="M23 22.1h4.9v4.1H23zM7 18.8l16 5.3M43.8 18.8l-15.9 5.3" /></g>
      )
    case "chart":
      return(
        <g {...props}><path d="M4.9 9.8v32.4h40V9.8H24.5L21.7 7H10.5L7.7 9.7z" /><path d="M8.6 12.7h32.7v25.8H8.6zM11.8 10.3h9.4M11.5 35.2h26.9" /><path d="M27.4 35.2V17.1h6.4v18.1M27.4 21.5h-6v13.7M21.4 28.3h-5.3v6.9" /></g>
      )
    case "lady":
      return(
        <g {...props} fill="transparent"><circle cx="11.2" cy="7.2" r="4" /><path d="M6.8 19.1L3.1 37.5h16.3l-3.6-18.2 10.6 4.8 1.6-3.3-12.8-7H6.3l-3.2 2.6v11.8h1.8M6.7 37.9v8.3h8.6v-8.3M11 37.9v7.9M29.7 12v33.8M21.5 28.9h25.9" /><path d="M23.4 18.3c1.7-4 4.4-6.5 7.3-6.5 5.2 0 9.4 7.6 9.4 17.1S35.9 46 30.8 46s-9.4-7.6-9.4-17.1c0-2.2.2-4.5.7-6.7" /><path d="M20.8 14.5c7.9-5.1 18.5-2.8 23.6 5.1s2.9 18.5-5 23.7c-6.8 4.4-15.8 3.4-21.5-2.3 1.4-1.9 6.5-3.2 12.2-3.2 5.6 0 10.4 1.3 12 3.2" /><path d="M42.3 17c-1.4 1.9-6.3 3.4-12.2 3.4-1.1 0-2.1-.1-3.1-.1" /></g>
      )
    case "people":
      return (
        <g {...props}><circle cx="26" cy="8" r="4.1" /><path d="M19.9 27.3h-1.5V16.9c0-1.6 1.3-2.9 2.9-2.9h8.5c1.6 0 2.9 1.3 2.9 2.9v10.5h-1.6" /><circle cx="15.4" cy="9" r="3.7" /><path d="M10.5 29.9H7.2V17.6c0-1.6 1.3-2.9 2.9-2.9h5.7M21.7 17.9l-3.5 18.5H33l-3.6-18.5M21.3 36.4v9.3h8.4v-9.3M25.5 36.4v9.4" /><path d="M10.5 19.5v24.9h8.2M15 29v15.4" /><circle cx="36" cy="9" r="3.7" /><path d="M40.8 29.9h3.3V17.6c0-1.6-1.3-2.9-2.9-2.9h-5.7" /><path d="M40.8 19.5v24.9h-8.2M36.3 29v15.4" /></g>
      )
    case "marker":
      return (
        <g {...props} fill="transparent"><path d="M30.8 13.5c0 6.3-10.6 17.5-10.6 17.5S9.5 19.8 9.5 13.5C9.5 7.1 15 3.4 20.1 3.4s10.7 3.7 10.7 10.1z" /><circle cx="20.1" cy="14" r="3.2" /><path d="M12.7 27.4c-4.5.7-7.5 2.1-7.5 3.7 0 2.3 6.7 4.3 14.9 4.3S35 33.5 35 31.1c0-1.6-3-2.9-7.5-3.7" /></g>
      )
    case "next":
      return (
        <g {...props}><path d="M1.5 19l9-9-9-9" /></g>
        )
    case "prev":
      return (
        <g {...props}><path d="M10.5 1l-9 9 9 9"/></g>
      )
    case "up":
      return (
        <g {...props}><path fill="transparent" d="M19 10.5l-9-9-9 9"/></g>
      )
    case "down":
      return (
        <g {...props}><path fill="transparent" d="M1 1.5l9 9 9-9"/></g>
      )
    case "binoculars":
      return (
        <g {...props}><circle cx="16.4" cy="27.4" r="6.4" /><circle cx="25.4" cy="27.5" r=".9" /><path d="M13.5 28.5c-.2-.3-.2-.7-.2-1.1 0-1.7 1.4-3.1 3.2-3.1h.6" /><circle cx="34.2" cy="27.5" r="6.4" /><path d="M31.3 28.5c-.2-.3-.2-.7-.2-1.1 0-1.7 1.4-3.1 3.2-3.1h.6M21 23s3.6 3 8.7 0M21 31.9s3.5-3 8.4 0M23.3 20.6c-.1-.8-.3-1.6-.7-2.3-.9-1.5-2.7-1.9-4.3-1.4-1.7.5-3 1.9-4 3.2-.4.5-.8 1.1-1.1 1.7M27.1 20.6c.1-.8.3-1.6.7-2.3.9-1.5 2.7-1.9 4.3-1.4s3 1.9 4 3.2c.4.5.8 1.1 1.1 1.7M22.4 18h5.5" /></g>
      )

    default:
      return <path />;
  }
};

const SVGIcon = ({
  name = "",
  style = {},
  fill = "#fff",
  stroke = "#fff",
  strokeWidth = ".803",
  fillRule = "evenodd",
  viewBox = "",
  width = "100%",
  className = "",
  height = "100%"
}) => (
    <svg
      width={width}
      style={style}
      height={height}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox || getViewBox(name)}
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      {getPath(name, {fill,stroke,strokeWidth,fillRule})}
    </svg>
  );

export default SVGIcon;
